import React, { useState } from 'react';
import { PageHeader, Button } from '../../components';
import styles from './Settings.module.css';

const Settings = () => {
  const [activeTab, setActiveTab] = useState('study');
  const [autoApprove, setAutoApprove] = useState(true);
  const [blockGovId, setBlockGovId] = useState(true);
  const [warnMinIncentive, setWarnMinIncentive] = useState(false);
  const [require2FA, setRequire2FA] = useState(true);
  const [minAge, setMinAge] = useState('18');
  const [slaHours, setSlaHours] = useState('24');
  const [batchThreshold, setBatchThreshold] = useState('₹25,000');
  const [payoutProvider, setPayoutProvider] = useState('RazorpayX');

  const handleSave = () => {
    alert('Settings saved successfully.');
  };

  const tabs = [
    { key: 'study', label: 'Study rules' },
    { key: 'verification', label: 'Verification' },
    { key: 'payouts', label: 'Payouts' },
    { key: 'security', label: 'Security' }
  ];

  return (
    <div className={styles.container}>
      <PageHeader
        title="Settings"
        subtitle="Platform rules for studies, verification and payouts."
        actions={
          <Button variant="primary" onClick={handleSave}>
            Save changes
          </Button>
        }
      />

      <div className={styles.tabsContainer}>
        {tabs.map((tab) => (
          <button
            key={tab.key}
            type="button"
            onClick={() => setActiveTab(tab.key)}
            className={activeTab === tab.key ? styles.tabButtonActive : styles.tabButton}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className={styles.settingsGrid}>
        <section className={styles.cardSection}>
          <h2 className={styles.sectionTitle}>Study rules</h2>

          <div
            className={styles.toggleRow}
            onClick={() => setAutoApprove(!autoApprove)}
            role="button"
            tabIndex={0}
          >
            <div className={styles.toggleInfo}>
              <span className={styles.toggleLabel}>
                Auto-approve trusted researchers
              </span>
              <span className={styles.toggleDescription}>
                Skip manual review for accounts with 5+ approved studies and no flags
              </span>
            </div>
            <div
              className={`${styles.toggleSwitch} ${
                autoApprove ? styles.toggleSwitchActive : ''
              }`}
            >
              <span
                className={`${styles.toggleKnob} ${
                  autoApprove ? styles.toggleKnobActive : ''
                }`}
              />
            </div>
          </div>

          <div
            className={styles.toggleRow}
            onClick={() => setBlockGovId(!blockGovId)}
            role="button"
            tabIndex={0}
          >
            <div className={styles.toggleInfo}>
              <span className={styles.toggleLabel}>
                Block government ID requests in screeners
              </span>
              <span className={styles.toggleDescription}>
                Studies can't ask participants for Aadhaar, PAN or passport numbers
              </span>
            </div>
            <div
              className={`${styles.toggleSwitch} ${
                blockGovId ? styles.toggleSwitchActive : ''
              }`}
            >
              <span
                className={`${styles.toggleKnob} ${
                  blockGovId ? styles.toggleKnobActive : ''
                }`}
              />
            </div>
          </div>

          <div
            className={styles.toggleRow}
            onClick={() => setWarnMinIncentive(!warnMinIncentive)}
            role="button"
            tabIndex={0}
          >
            <div className={styles.toggleInfo}>
              <span className={styles.toggleLabel}>
                Minimum incentive per hour
              </span>
              <span className={styles.toggleDescription}>
                Warn reviewers below ₹300 per hour of participation
              </span>
            </div>
            <div
              className={`${styles.toggleSwitch} ${
                warnMinIncentive ? styles.toggleSwitchActive : ''
              }`}
            >
              <span
                className={`${styles.toggleKnob} ${
                  warnMinIncentive ? styles.toggleKnobActive : ''
                }`}
              />
            </div>
          </div>

          <div className={styles.inputRow}>
            <label className={styles.formLabel}>
              Minimum participant age
              <input
                value={minAge}
                onChange={(e) => setMinAge(e.target.value)}
                className={styles.textInput}
              />
            </label>
            <label className={styles.formLabel}>
              Approval SLA (hours)
              <input
                value={slaHours}
                onChange={(e) => setSlaHours(e.target.value)}
                className={styles.textInput}
              />
            </label>
          </div>
        </section>

        <div className={styles.rightColumn}>
          <section className={styles.cardSection}>
            <h2 className={styles.sectionTitle}>Payout rules</h2>

            <label className={styles.formLabel}>
              Batch approval needed above
              <input
                value={batchThreshold}
                onChange={(e) => setBatchThreshold(e.target.value)}
                className={styles.textInput}
              />
            </label>

            <label className={styles.formLabel}>
              Payout provider
              <input
                value={payoutProvider}
                onChange={(e) => setPayoutProvider(e.target.value)}
                className={styles.textInput}
              />
            </label>

            <div
              className={styles.toggleRow}
              onClick={() => setRequire2FA(!require2FA)}
              role="button"
              tabIndex={0}
            >
              <div className={styles.toggleInfo}>
                <span className={styles.toggleLabel}>
                  Require 2FA for payout approval
                </span>
                <span className={styles.toggleDescription}>
                  Finance and Super admins only
                </span>
              </div>
              <div
                className={`${styles.toggleSwitch} ${
                  require2FA ? styles.toggleSwitchActive : ''
                }`}
              >
                <span
                  className={`${styles.toggleKnob} ${
                    require2FA ? styles.toggleKnobActive : ''
                  }`}
                />
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Settings;
